import React from 'react';
import '../App.css';

function Mission() {
  return (
    <div className="about">
      <header className="about-header">
        <h2>About Us</h2>
        <h4>Welcome to Jays Woodwork! </h4>
        <p>
            Based out of Alpharetta, GA and started by Jayadev Anne as a passion project in and for his own home, we specialize in crafting bespoke wooden mandriams that are as unique as your own faith. 
            A mandir is not just a piece of some furniture, it's the heart of spiritual practice in your home. This is why we work closely with you to 
            design and build a custom mandir that resonates with your onw personal style and devotional needs. 
            All the materials used are handpicked and inspected to make sure the mandirams are built with the best quality possible. 
            We're dedicated to deliver the best experience of owning your own mandiram right from choosing the type of wood, 
            the design to setting it up in your home. Let us be the bridge between your devotion and the divine.
        </p>
      </header>
    </div>
  );
}

export default Mission;
